export default {
  docs_welcome: 'Welcome to MBE Wiki',
  docs_introduce_title: 'Introduction',
  docs_introduce:
    'MBE Wiki covers product introductions such as platforms and devices, providing viewing functions such as help documents, videos, and alarm documents to help you better use the platform and maintenance device',
  docs_category_title: 'Doc Categories',
  docs_search_placeholder: 'Please enter keywords, such as name/account creation',
  docs_search_category_placeholder: 'All knowledge categories',
  docs_search_status_placeholder: 'All statuses',
  docs_search_button: 'Full-text search',
  docs_help_title: 'Help Documents',
  docs_manage_title: 'Document Management',
  docs_category_manage_title: 'Category Management',
  docs_return_list: 'Return',
  docs_props: 'Document Properties',

  docs_search_loading_text: 'Searching...',
  docs_search_result1: 'Full-text search found',
  docs_search_result2: 'results for you',
  docs_search_lz: 'from',
  docs_detail_base_info: 'Basic Information',
  docs_detail_base_status: 'Status',
  docs_detail_base_createBy: 'Created by',
  docs_detail_base_createTime: 'Creation time',
  docs_detail_base_updateBy: 'Last modified by',
  docs_detail_base_updateTime: 'Last modified time',
  docs_detail_base_description: 'Document description',
  docs_detail_path: 'Path',
  docs_status_enable: 'Enabled',
  docs_status_disable: 'Disabled',
  docs_disable: 'Disable',
  docs_enable: 'Enable',

  docs_share_title: 'Share Document',
  docs_operation_delete: 'Are you sure you want to delete this document?',
  docs_operation_disable: 'Are you sure you want to disable this document?',
  docs_operation_enable: 'Are you sure you want to enable this document?',

  docs_title: 'Document',
  docs_detail_title: 'Details',
  docs_update_title: 'Update',
  docs_add_title: 'Add',
  docs_add_category_title: 'New Category',
  docs_edit_category_title: 'Edit Category',

  // table
  docs_table_title: 'Title',
  docs_table_delete_config: 'Are you sure you want to delete this document?',
  docs_table_category_name: 'Category Name',
  docs_table_category_description: 'Category Description',

  // form
  docs_form_add_title: 'Add Document',
  docs_form_edit_title: 'Edit Document',
  docs_form_edit_prop_title: 'Edit Properties',
  docs_form_title: 'Title',
  docs_form_title_placeholder: 'Please enter title',
  docs_form_name: 'Document Name',
  docs_form_name_placeholder: 'Please enter document name',
  docs_form_type: 'Document Type',
  docs_form_type_placeholder: 'Please enter document type',
  docs_form_type_help:
    // '100 表示设备告警信息（alarm）文档，101 表示设备配置信息文档，102 表示设备运行信息文档；其他类型待定',
    '100 represents device alarm information (alarm) document, 101 represents device configuration information document, 102 represents device operation information document; other types are pending',
  docs_form_category: 'Knowledge Category',
  docs_form_category_placeholder: 'Select knowledge category',
  docs_form_description: 'Document Description',
  docs_form_description_placeholder: 'Please enter document description',
  docs_form_icon: 'Document Icon',
  docs_form_icon_placeholder: 'Only jpg/png files are allowed, and not exceeding 500kb',
  docs_form_auth: 'Permission',
  docs_form_auth_read: 'Document read permission',
  docs_form_auth_write: 'Document write permission',
  docs_form_auth_placeholder: 'Please select permission level',
  docs_form_category_name: 'Please enter category name',
  docs_form_category_icon: 'Category icon',
  docs_form_docs_icon: 'Document icon',
  docs_form_category_delete_confirm: 'Are you sure you want to delete this category?',
  docs_form_content_save_confirm: 'Are you sure you want to save the document content?',
};
